module.exports = __webpack_public_path__ + "media/images/icons/icon_edit_primary-3ea0b6887d86ab6682f8b4038ce61119.svg";